<sc-flex fitHeight vertical stretchContent>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      @for (condition of currentTruckGroup.conditions; track condition) {
        <div>
          <app-truck-group-condition [condition]="condition"
          (removeCondition)="removeCondition($event)"></app-truck-group-condition>
        </div>
      }
    </sc-scroll-pane>
  </sc-flex-fitting-content>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>
    <sc-flex centered>
      <sc-action-icon iconClass="fa-plus" (click)="onAddHandle()"></sc-action-icon>
    </sc-flex>
  </div>
</sc-flex>